import React from 'react';
import styled from 'styled-components';

const TextContainer = styled.div`
  color: #2c3e50;
  line-height: 1.8;
  font-size: 1rem;
  
  p {
    margin-bottom: 16px;
    text-align: left;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

interface SimpleProductTextProps {
  text: string;
}

const SimpleProductText: React.FC<SimpleProductTextProps> = ({ text }) => {
  if (!text || text.trim().length === 0) {
    return <p>Ingen produktbeskrivning tillgänglig.</p>;
  }

  // Simple text formatting: split long text into readable paragraphs
  const formatText = (text: string): string[] => {
    // Clean the text
    const cleanText = text.trim().replace(/\s+/g, ' ');
    
    // Split by sentences and group into paragraphs
    const sentences = cleanText.split(/[.!?]+/).filter(s => s.trim().length > 0);
    const paragraphs: string[] = [];
    let currentParagraph = '';
    
    for (let i = 0; i < sentences.length; i++) {
      const sentence = sentences[i].trim();
      if (!sentence) continue;
      
      // Add sentence to current paragraph
      currentParagraph += (currentParagraph ? '. ' : '') + sentence;
      
      // Start new paragraph after 2-3 sentences or if sentence is very long
      if ((i + 1) % 2 === 0 || currentParagraph.length > 200) {
        paragraphs.push(currentParagraph + '.');
        currentParagraph = '';
      }
    }
    
    // Add remaining text
    if (currentParagraph) {
      paragraphs.push(currentParagraph + (currentParagraph.endsWith('.') ? '' : '.'));
    }
    
    return paragraphs.length > 0 ? paragraphs : [cleanText];
  };

  const paragraphs = formatText(text);

  return (
    <TextContainer>
      {paragraphs.map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
      ))}
    </TextContainer>
  );
};

export default SimpleProductText;